import { render, staticRenderFns } from "./db-groups-modal-create-edit-form.vue?vue&type=template&id=6c998f62&"
import script from "./db-groups-modal-create-edit-form.vue?vue&type=script&lang=js&"
export * from "./db-groups-modal-create-edit-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports